export enum EnumTypeProcessAsn {
  Inbound = 1,
  Return = 2
}
